import { Injectable } from "@angular/core"
import { Actions, Effect } from "@ngrx/effects"
import { Action } from "@ngrx/store"
import { TutorAllocationService } from "@services/tutor-allocation";
import { Observable } from "rxjs/Observable"
import { TutorAllocation } from "@models/tutor-allocation";
import { TutorTimeslots } from "@models/tutor-timeslots";
import {
  POPULATE_TUTOR_ALLOCATIONS,
  FETCH_TUTOR_ALLOCATIONS,
  FETCH_TUTOR_ALLOCATIONS_FAILURE,
  CREATE_TUTOR_ALLOCATION,
  ADD_TUTOR_ALLOCATION,
  CREATE_TUTOR_ALLOCATION_FAILURE,
  UPDATE_TUTOR_ALLOCATION,
  UPDATE_TUTOR_ALLOCATION_FAILURE,
  REPLACE_TUTOR_ALLOCATION,
} from "../tutor-allocations";

@Injectable()
export class TutorAllocationEffects {

  constructor(
    private actions: Actions,
    private tutorAllocationService: TutorAllocationService,
  ) {}

  @Effect() index = this.actions
    .ofType(FETCH_TUTOR_ALLOCATIONS)
    .map((action: Action) => action.payload)
    .switchMap(() => this.tutorAllocationService.index()
      .map((tas: TutorAllocation[]) => ({ type: POPULATE_TUTOR_ALLOCATIONS, payload: tas }))
      .catch(() => Observable.of({ type: FETCH_TUTOR_ALLOCATIONS_FAILURE }))
    )
    .share()

  @Effect() create = this.actions
    .ofType(CREATE_TUTOR_ALLOCATION)
    .map((action: Action) => action.payload)
    .switchMap((ta: TutorAllocation) => this.tutorAllocationService.create(ta)
      .map((ta: TutorAllocation) => {
        return { type: ADD_TUTOR_ALLOCATION, payload: ta }
      })
      .catch(() => Observable.of({ type: CREATE_TUTOR_ALLOCATION_FAILURE }))
    )
    .share()

  @Effect() update = this.actions
    .ofType(UPDATE_TUTOR_ALLOCATION)
    .map((action: Action) => action.payload)
    .switchMap((ta: TutorAllocation) => this.tutorAllocationService.update(ta)
      .map((ta: TutorAllocation) => {
        return { type: REPLACE_TUTOR_ALLOCATION, payload: ta }
      })
      .catch(() => Observable.of({ type: UPDATE_TUTOR_ALLOCATION_FAILURE }))
    )
    .share()

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/reducers/effects/tutor-allocation.ts